const BREAKPOINTS = {
  DESKTOP: 1024,
  DESKTOP_LARGE: 1280
};

const SETTINGS = {
  THROTTLE_DELAY_SMALL: 50,
  THROTTLE_DELAY: 500,
  SEARCH_DEBOUNCE_DELAY: 300,
  MINICART_DEBOUNCE_DELAY: 300,
  FILTER_UPDATE_DELAY: 250,
  FILTER_DRAW_ANIMATION_TIME: 300,
  MEGA_MENU_CLOSE_DELAY: 200
};

const CART = {
  FORM_SUBMIT_TIMEOUT: 2000
};

const PRODUCT_RECENTLY_VIEWED = {
  MINIMUM_PRODUCTS_TO_SHOW: 3,
  MAX_CONTENT_CHARS_AMOUNT: 26
};

const CLASSES = {
  TRANSLATE_X_0: 'translate-x-0',
  TRANSLATE_X_100: 'translate-x-full',
  OVERFLOW_HIDDEN: 'overflow-hidden',
  SCROLLABLE: 'overflow-y-auto'
};

const ARIAS = {
  EXPANDED: 'aria-expanded'
};

const SWIPER = {
  SLIDE_CLASS: '.swiper-slide'
};

const WISHLIST = {
  APP_ADDED_CLASSES: ['unbookmarked', 'bookmarked', 'sw_tooltip', 'tooltip', 'tooltipstered'],
  ADDED_TO_CART_EVENT: 'sw:addedtocart'
};

const SELECTORS = {
  LOADING_SPINNER: '[data-loading-spinner]'
};

export {
  BREAKPOINTS,
  SETTINGS,
  CART,
  PRODUCT_RECENTLY_VIEWED,
  CLASSES,
  ARIAS,
  SWIPER,
  WISHLIST,
  SELECTORS
};
